export default function (name) {
  if (!name) return;

  return name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
